/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};


jQuery(document).ready(function($){
    var dragging = false,
        scrolling = false,
        resizing = false;
    //cache jQuery objects
    var imageComparisonContainers = $('.cd-image-container');
    //check if the .cd-image-container is in the viewport 
    //if yes, animate it
    checkPosition(imageComparisonContainers);
    $(window).on('scroll', function(){
        if( !scrolling) {
            scrolling =  true;
            ( !window.requestAnimationFrame )
                ? setTimeout(function(){checkPosition(imageComparisonContainers);}, 100)
                : requestAnimationFrame(function(){checkPosition(imageComparisonContainers);});
        }
    });
    
    //make the .cd-handle element draggable and modify .cd-resize-img width according to its position
    imageComparisonContainers.each(function(){
        var actual = $(this);
        drags(actual.find('.cd-handle'), actual.find('.cd-resize-img'), actual, actual.find('.cd-image-label[data-type="original"]'), actual.find('.cd-image-label[data-type="modified"]'));
    });

    //upadate images label visibility
    $(window).on('resize', function(){
        if( !resizing) {
            resizing =  true;
            ( !window.requestAnimationFrame )
                ? setTimeout(function(){checkLabel(imageComparisonContainers);}, 100)
                : requestAnimationFrame(function(){checkLabel(imageComparisonContainers);});
        }
    });

    function checkPosition(container) {
        container.each(function(){
            var actualContainer = $(this);
            if( $(window).scrollTop() + $(window).height()*0.5 > actualContainer.offset().top) {
                actualContainer.addClass('is-visible');
            }
        });

        scrolling = false;
    }

    function checkLabel(container) {
        container.each(function(){
            var actual = $(this);
            updateLabel(actual.find('.cd-image-label[data-type="modified"]'), actual.find('.cd-resize-img'), 'left');
            updateLabel(actual.find('.cd-image-label[data-type="original"]'), actual.find('.cd-resize-img'), 'right');
        });

        resizing = false;
    }

    //draggable funtionality - credits to http://css-tricks.com/snippets/jquery/draggable-without-jquery-ui/
    function drags(dragElement, resizeElement, container, labelContainer, labelResizeElement) {
        dragElement.on("mousedown vmousedown", function(e) {
            dragElement.addClass('draggable');
            resizeElement.addClass('resizable');

            var dragWidth = dragElement.outerWidth(),
                xPosition = dragElement.offset().left + dragWidth - e.pageX,
                containerOffset = container.offset().left,
                containerWidth = container.outerWidth(),
                minLeft = containerOffset + 10,
                maxLeft = containerOffset + containerWidth - dragWidth - 10;
            
            dragElement.parents().on("mousemove vmousemove", function(e) {
                if( !dragging) {
                    dragging =  true;
                    ( !window.requestAnimationFrame )
                        ? setTimeout(function(){animateDraggedHandle(e, xPosition, dragWidth, minLeft, maxLeft, containerOffset, containerWidth, resizeElement, labelContainer, labelResizeElement);}, 100)
                        : requestAnimationFrame(function(){animateDraggedHandle(e, xPosition, dragWidth, minLeft, maxLeft, containerOffset, containerWidth, resizeElement, labelContainer, labelResizeElement);});
                }
            }).on("mouseup vmouseup", function(e){
                dragElement.removeClass('draggable');
                resizeElement.removeClass('resizable');
            });
            e.preventDefault();
        }).on("mouseup vmouseup", function(e) {
            dragElement.removeClass('draggable');
            resizeElement.removeClass('resizable');
        });
    }

    function animateDraggedHandle(e, xPosition, dragWidth, minLeft, maxLeft, containerOffset, containerWidth, resizeElement, labelContainer, labelResizeElement) {
        var leftValue = e.pageX + xPosition - dragWidth;   
        //constrain the draggable element to move inside his container
        if(leftValue < minLeft ) {
            leftValue = minLeft;
        } else if ( leftValue > maxLeft) {
            leftValue = maxLeft;
        }

        var widthValue = (leftValue + dragWidth/2 - containerOffset)*100/containerWidth+'%';
        
        $('.draggable').css('left', widthValue).on("mouseup vmouseup", function() {
            $(this).removeClass('draggable');
            resizeElement.removeClass('resizable');
        });

        $('.resizable').css('width', widthValue); 

        updateLabel(labelResizeElement, resizeElement, 'left');
        updateLabel(labelContainer, resizeElement, 'right');
        dragging =  false;
    }

    function updateLabel(label, resizeElement, position) {
        if(position == 'left') {
            ( label.offset().left + label.outerWidth() < resizeElement.offset().left + resizeElement.outerWidth() ) ? label.removeClass('is-hidden') : label.addClass('is-hidden') ;
        } else {
            ( label.offset().left > resizeElement.offset().left + resizeElement.outerWidth() ) ? label.removeClass('is-hidden') : label.addClass('is-hidden') ;
        }
    }
  
//   $('.imgInner').find('.imgText_two').slideUp();
  
  
//   $('.imgInner').find('.imgText_two').animate({
//     height: "auto";
//   }, 1500 );
  
  /*jQuery.getJSON('/products/red-rain-coat.js', function(product) {
    alert('The title of this product is ' + product.title);
  } );*/
  
  $('form[action="/cart/add"]').submit(function(e){
    e.preventDefault();
    
    $.ajax({
      url: '/cart/add.js',
      type:'POST',
      data: $('form[action="/cart/add"]').serialize(),
      dataType:'json',
      success: function(result){
        console.log(result);
        //var v = generateCart();
        generateCart();
        /*jQuery.getJSON('/cart.js', function(data) {
          //console.log(data);
          $('.cart_li .Cart_Total').html(data.item_count);
          if(data.item_count > 0){
            var detail = '';
            var item = '<ul>';
            $.each(data.items, function(k,v){
              var key = k+1;
              item += '<li data-item-index="'+key+'"><a href="'+v.url+'" class="Single__Item">';
              item += '<div class="Item-Feature__img"><img src="'+v.image+'"></div>';
              item += '<div class="Item-Meta__Detail">'+
                '<h4 class="Produt__Title">'+v.title+'</h4>'+ 
                '<span class="Product__Qty">Qty : '+v.quantity+'</span>'+ 
                '<span class="Product__Price">'+Shopify.formatMoney(v.price, window.theme.moneyFormat)+'</span>'+
                '</div></a><li>';
            });
            item += '</ul>';
            detail += '<h3 class="Cart__title">Your cart</h3>'+
              '<span class="Item__Total">'+data.item_count +' item</span>'+
              item+
              '<p>Cart Subtotal : '+Shopify.formatMoney(data.total_price, window.theme.moneyFormat)+'</p>';
            
            var finalHtml = '<div class="CartDrawer__Details">'+
                    '<form href="/cart" method="POST" class="Cart__Form">'+
                      '<div class="Cart--Form__Data" id="Cart--Form__Data">'+
                        detail
                      '</div>'+
                      '<button type="submit" name="checkout" class="Cart__Checkout Button Button--primary Button--full">{{ 'cart.general.checkout' | t }}</button>'+
                    '</form>'+
                  '</div>';
            $('.CartDraw__Body').html(finalHtml);
            
            
          }
        });*/

        $('.CartDraw').fadeIn('slow');
        setTimeout(function(){
          $('.CartDraw').fadeOut('slow')
        }, 2000);
      },
      error: function(e){
        alert(e.responseJSON.description);
      }
    });
    /*
    jQuery.post('/cart/add.js', $('form[action="/cart/add"]').serialize(), function(){
      console.log('dsf');
    }).done(function(data) {
      alert( "second success" );
      console.log(data);
    })
    .fail(function() {
      alert( "error" );
    });*/
  });
  //$('.cart_li')
});
generateCart();
function generateCart(){
  jQuery.getJSON('/cart.js', function(data) {
    //console.log(data);
    $('.cart_li .Cart_Total').html(data.item_count);
    if(data.item_count > 0){
      var detail = '';
      var item = '<ul>';
      $.each(data.items, function(k,v){
        var key = k+1;
        item += '<li data-item-index="'+key+'"><a href="'+v.url+'" class="Single__Item">';
        item += '<div class="Item-Feature__img"><img src="'+v.image+'"></div>';
        item += '<div class="Item-Meta__Detail">'+
          '<h4 class="Produt__Title">'+v.title+'</h4>'+ 
          '<span class="Product__Qty">Qty : '+v.quantity+'</span>'+ 
          '<span class="Product__Price">'+Shopify.formatMoney(v.price, window.theme.moneyFormat)+'</span>'+
          '</div></a><li>';
      });
      item += '</ul>';
      detail += '<h3 class="Cart__title">Your cart</h3>'+
        '<span class="Item__Total">'+data.item_count +' item</span>'+
        item+
        '<p>Cart Subtotal : '+Shopify.formatMoney(data.total_price, window.theme.moneyFormat)+'</p>';

      var finalHtml = '<div class="CartDrawer__Details">'+
          '<form href="/cart" method="POST" class="Cart__Form">'+
          '<div class="Cart--Form__Data" id="Cart--Form__Data">'+detail+'</div>'+
        '<button type="submit" name="checkout" class="Cart__Checkout Button Button--primary Button--full">Checkout</button>'+
          '</form>'+
          '</div>';
      $('.CartDraw__Body').html(finalHtml);

    }
  });
}
